import 'virtual:svg-icons-register'
import Swiper from 'swiper'
window.Swiper = Swiper
import './core/enable-transitions.js'
import './core/breadcrumb.js'
import './header/header.js'
import './header/searchbar.js'
import './search/kesearch-suggest.js'
import './core/back-to-top.js'
import './slider/slider.js'
import './storefinder/modal.js'
import './accordion/accordion.js'
import './download/download.js'
import './products/show.js'
import './products/wishlist.js'
import './products/filtering-config.js'
import './products/title.js'
